import { useCallback } from "react";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { editStorageObject } from "../../../app/state/storageObjectSlice/actions/actions";
import { useStorageSelectors } from "../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { NormalizedStorageObject } from "../../../services/api/instances/storageApi/types/object_types";
import { AssistantValue } from "../../../services/api/instances/assistantsApi/types";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import { selectMeetingValue } from "../redux/selectors";
import {
  setMeetingSelectedAssistant,
  updateMeetingValueField,
} from "../redux/slice";
import {
  ModelServiceState,
  TModelItem,
} from "../../../services/api/instances/modelsApi/types";
import { MeetingsValue } from "../../../services/api/instances/meetingsApi/types";

export const useLLMSelections = () => {
  const dispatch = useAppDispatch();
  const value = useAppSelector(selectMeetingValue);
  const { selectedObject } = useStorageSelectors("meetings");

  const handleSelectAssistant = useCallback(
    (assistant: NormalizedStorageObject<AssistantValue> | null) => {
      dispatch(setMeetingSelectedAssistant(assistant));
      const ref = assistant ? assistant.ref : null;
      const modelName = value?.meetings_object?.llm_selection?.model || null;
      dispatch(
        updateMeetingValueField({
          llm_selection: {
            assistant_ref: ref,
            model: modelName,
          },
        }),
      );
      if (value?.meetings_object) {
        const updatedValue: MeetingsValue = {
          meetings_object: {
            ...value.meetings_object,
            llm_selection: {
              assistant_ref: ref,
              model: modelName,
            },
          },
        };

        dispatch(
          editStorageObject({
            id: selectedObject?.id as string,
            name: selectedObject?.friendly_name as string,
            value: updatedValue,
            service: "meetings",
          }),
        );
      }
    },
    [dispatch, value, selectedObject],
  );

  const handleSelectModel = useCallback(
    (model: TModelItem | null) => {
      if (!model) return;
      const modelName = model ? model.id : null;
      dispatch(
        updateMeetingValueField({
          llm_selection: {
            assistant_ref: modelName && null,
            model: modelName,
          },
        }),
      );
      if (value?.meetings_object) {
        const updatedValue: MeetingsValue = {
          meetings_object: {
            ...value.meetings_object,
            llm_selection: {
              assistant_ref: modelName && null,
              model: modelName,
            },
          },
        };
        dispatch(
          editStorageObject({
            id: selectedObject?.id as string,
            name: selectedObject?.friendly_name as string,
            value: updatedValue,
            service: "meetings",
          }),
        );
      }
    },
    [dispatch, value, selectedObject],
  );

  return {
    handleSelectAssistant,
    handleSelectModel,
  };
};
